import { Body, H4, Stack, useWindowProperties } from '@qred/components-library';
import React from 'react';
import BankConnection from '~/components/shared/BankConnection/BankConnection';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { GetClientDataResultType } from '~/store/apis/dtos/clientData/clientData.dto';
import { finishStep } from '~/store/slices/updateApplication/updateApplication.slice';

type NotConnectedAndHasClientDataProps = {
  clientData: GetClientDataResultType;
  error: boolean;
  setError: (error: boolean) => void;
};
const NotConnectedAndHasClientData = ({
  clientData,
  error,
  setError,
}: NotConnectedAndHasClientDataProps) => {
  const dispatch = useAppDispatch();
  const { isMobile } = useWindowProperties();
  const t = useTranslate();

  const handleSuccess = () => {
    dispatch(finishStep('enable_banking'));
  };

  return (
    <Stack spacing={isMobile ? 'md' : 'xl'} p="1.5em">
      <H4 data-testid="title" data-record>
        {t('BankConnectionStandalone.Title')}
      </H4>
      <Body size="lg" data-testid="description" data-record>
        {t('BankConnectionStandalone.Description')}
      </Body>
      <BankConnection
        clientId={clientData.clientId}
        hasError={error}
        setError={setError}
        onResult={handleSuccess}
        allowCancel={false}
      />
    </Stack>
  );
};

export default NotConnectedAndHasClientData;
